export default class CursoService {
  constructor(resource) {
    this._resource = resource;
  }

  getPeriodosAtivosByCurso(curso, login) {
    if (!curso || !login || String(curso).trim() === "") {
      console.warn("Busca de períodos abortada: 'curso' ou 'login' ausentes.", {
        curso,
        login
      });

      return Promise.reject(
        new Error(
          "Parâmetros insuficientes para buscar o período, tente novamente mais tarde."
        )
      );
    }

    const encodedCurso = encodeURIComponent(curso);
    const encodedLogin = encodeURIComponent(login);

    return this._resource
      .get(`corpore/curso/periodo/${encodedCurso}/${encodedLogin}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter os períodos");
        }
      );
  }

  getDisciplinasCurso(curso, disciplina = null, ra = null) {
    return this._resource
      .post("corpore/curso/disciplina", {
        curso,
        disciplina,
        ra
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter os períodos");
        }
      );
  }

  getCursosColegio() {
    return this._resource.get("corpore/curso/colegio").then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os cursos");
      }
    );
  }

  getTurmasCurso(curso, perletivo = null) {
    return this._resource
      .post("corpore/curso/turma", {
        curso,
        perletivo
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter as turmas");
        }
      );
  }
  getCursosGraduacao(ativo = 1, coligada = null) {
    return this._resource
      .get(`corpore/curso/getallCursosgraduacao/${ativo}`, {
        params: {
          coligada
        }
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter os horários");
        }
      );
  }

  getCursosGraduacaoEad() {
    return this._resource.get("corpore/curso/getallCursosgraduacaoEad").then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os cursos ead");
      }
    );
  }

  getCursosPos() {
    return this._resource.get("corpore/curso/pos").then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os cursos pós-graduação");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/CursoService.js